import { GET_COUNTRIES_LIST_API } from 'constants/AppConstants';

/**
 * Service to get the list of all the countries.
 * @returns {Object} - Response received from the API along with the ok status
 */
const getCountryList = async () => {
  try {
    const response = await fetch(GET_COUNTRIES_LIST_API.replace(), {
      method: 'GET',
    });
    const json = await response.json();
    return { ok: response.ok, json };
  } catch (error) {
    return { ok: false, json: { errorCode: '40029', errorDescription: 'Internal server error' } };
  }
};

export default getCountryList;
